export enum ProductAvailabilityKind {
	Rough,
	Precise,
	Fictive,
	Unknown,
}

export enum ProductAvailabilityColor {
	InStock = '#008030',
	AlmostOutOfStock = '#f19146',
	OutOfStock = '#cd0037',
	Unknown = '#4a4a4a',
}
